<template lang="pug">
  app-dialog(v-model="$_show" header="Редактировать документ базы знаний" :width="900" confirm-text="Сохранить" :confirm-disabled="!ready" @confirm="create")

    div(v-if="rootCategory && rootCategory.alias === 'common'")
      v-row
        .col-6
          v-menu
            template(v-slot:activator="{ on }")
              v-text-field.costomlb(v-model="cCategory" label="Раздел" v-on="on" outlined readonly)
            v-card
              v-treeview(dense activatable open-all return-object item-key="id" item-text="title" :active.sync="selectedCategory" :items="knowledgeCategory")
        .col-6
          app-text-field(v-model="editDoc.decree" label="Вид документа")
      v-row
        .col-6
          app-text-field(v-model="editDoc.judgeName" label="Автор")
        .col-6
          app-text-field(v-model="editDoc.number" label="Входящий номер")

      app-text-field(v-model="editDoc.clause" label="Название")
      v-textarea(v-model="editDoc.note" outlined label="Краткое содержание документа")

    div(v-else)
      v-row
        .col-6
          v-menu
            template(v-slot:activator="{ on }")
              v-text-field(v-model="cCategory" label="Раздел" v-on="on" outlined readonly)
            v-card
              v-treeview(dense activatable open-all return-object item-key="id" item-text="title" :active.sync="selectedCategory" :items="knowledgeCategory")
        .col-6
          app-select(v-model="editDoc.type" :items="typeList" label="Тип делопроизводства")
      v-row
        .col-6
          app-text-field(v-model="editDoc.year" label="Год")
        .col-6
          app-text-field(v-model="editDoc.clause" label="Статья")
      v-row
        .col-6
          app-text-field(v-model="editDoc.judgeName" label="Судья")
        .col-6
          app-text-field(v-model="editDoc.sides" label="Стороны")
      v-row
        .col-6
          app-text-field(v-model="editDoc.number" label="Номер")
        .col-6
          app-text-field(v-model="editDoc.colleg" label="Состав коллегии")
      v-row
        .col-6
          app-text-field(v-model="editDoc.decree" label="Принятое решение")
        .col-6
          app-select(v-model="editDoc.decreeState" :items="decreeStateList" label="Решение")

    v-row
      .col-6
        app-date-picker(v-model="editDoc.date" view-format="DD.MM.YYYY")
      .col-6
        app-file-input(v-model="editDoc.fileExt" :formats="[]" :maxSize="maxFileSize")

</template>

<script>
import { mapGetters, mapState } from 'vuex'
import { AppDialogToggable } from "@/components"
import Uploader from '@/common/Uploader'

export default {
  mixins: [AppDialogToggable, Uploader],
  computed: {
    ...mapState('knowledgeBase', ['knowledgeCategory','decreeStateList','typeList']),
    ...mapGetters('knowledgeBase', ['gKnowledgeCategory', 'gKnowledgeDocs','gDecreeStateList','gTypeList']),

    cCategory() {
      if (this.selectedCategory[0]) return this.selectedCategory[0].title
      return ''
    },

    rootCategory(){
      if (this.selectedCategory[0]) {
        return this.findRootCatSelected(this.selectedCategory[0])
      }
      return null
    },

    ready () {
      let docReady = false
      if (this.rootCategory && this.rootCategory.alias === 'common') {
        docReady = !!this.selectedCategory && !!this.selectedCategory[0] && !!this.editDoc.clause && !!this.editDoc.judgeName && !!this.editDoc.number && !!this.editDoc.decree && !!this.editDoc.note && !!this.editDoc.date //&& !!this.editDoc.fileExt
      } else if (this.selectedCategory[0] && (this.selectedCategory[0].alias === 'appeal' || this.selectedCategory[0].alias === 'cassation')) {
        docReady = !!this.editDoc.type && !!this.editDoc.date && !!this.editDoc.fileExt
      } else {
        docReady = !!this.selectedCategory && !!this.selectedCategory[0] && !!this.editDoc.year && (/^\d{1,4}$/i).test(this.editDoc.year) && !!this.editDoc.clause && !!this.editDoc.judgeName && !!this.editDoc.sides && !!this.editDoc.number && !!this.editDoc.decree && !!this.editDoc.decreeState && !!this.editDoc.type && !!this.editDoc.colleg && !!this.editDoc.date //&& !!this.editDoc.fileExt
      }
      if (this.editDoc.fileExt && this.editDoc.fileExt.size > this.maxFileSize) docReady = false
      return docReady
    },
  },

  methods: {

    $_beforeShow (doc) {
      this.editDoc = {knowledgeCategory:null, year: null, clause: null, judgeName: null, sides: null, number: null, date: null, decree: null, decreeState: null, type: null, colleg:null, note:null, fileExt: null };
      this.editDoc = Object.assign({}, doc);
      if (this.editDoc.fileExt != null && this.editDoc.fileExt != ''){
        this.oldFileName = this.editDoc.fileExt;
        this.editDoc.fileExt = new File([""], this.oldFileName);
      }
      this.selectedCategory = [{...this.editDoc.knowledgeCategory}]
      //this.selectedCategory.push(this.editDoc.knowledgeCategory)
      
    },

    create () {
      this.editDoc.knowledgeCategory = this.selectedCategory[0];
      if (this.editDoc.fileExt != null && this.editDoc.fileExt.name != this.oldFileName) {
        this.$_uploadFile(this.editDoc.fileExt).then(name => {
          this.saveEdit(name)
        })
      } else if (this.editDoc.fileExt != null) {
        this.saveEdit(this.editDoc.fileExt.name)
      } else {
        this.saveEdit(null)
      }
    },

    findRootCatSelected(item){
      return this.findRootCatSelectedRec(this.knowledgeCategory,item)
    },

    findRootCatSelectedRec(arr,item){
      let rootCat = arr.filter(i => {return i.id == item.id})[0]
      if (!rootCat){
        for (let itm of arr) {
          let cc = this.findRootCatSelectedRec(itm.children,item)
          if (cc) {
            rootCat = itm
            break
          }
        }
      }
      return rootCat
    },

    saveEdit(fileName){
        let o = {};
        if (this.rootCategory && this.rootCategory.alias === 'common') {
          o = {
            id:this.editDoc.id,
            knowledgeCategory:this.editDoc.knowledgeCategory,
            clause:this.editDoc.clause,
            judgeName:this.editDoc.judgeName,
            number:this.editDoc.number,
            date:this.editDoc.date+' 00:00',
            decree:this.editDoc.decree,
            year:null,
            sides:null,
            decreeState:null,
            type:null,
            colleg:null,
            note:this.editDoc.note,
            fileExt:fileName
          };
        } else {
          o = {
            id:this.editDoc.id,
            knowledgeCategory:this.editDoc.knowledgeCategory,
            type:this.editDoc.type.value,
            year:this.editDoc.year,
            clause:this.editDoc.clause,
            judgeName:this.editDoc.judgeName,
            sides:this.editDoc.sides,
            number:this.editDoc.number,
            date:this.editDoc.date+' 00:00',
            colleg:this.editDoc.colleg,
            decree:this.editDoc.decree,
            decreeState: this.editDoc.decreeState ? this.editDoc.decreeState.value : null,
            note:this.editDoc.note,
            fileExt:fileName
          };
        }
        this.$store.dispatch('knowledgeBase/editKnowledgeDoc',o)
    }

  },

  data () {
    return {
      maxFileSize:50240000,
      selectedCategory:[],
      editDoc:{},
      oldFileName:null
    }
  },
}
</script>

<style lang="scss" scoped>
  .v-menu.v-menu--inline{display:none;}
  .col-6{padding:0 12px;}
</style>
<style lang="scss">
  .costomlb .v-label {background: #fff;padding-right: 5px;}
</style>